import React from 'react';

import PropTypes from 'prop-types';

import { Table } from '@shared/components';

import columns from './advancementReportTableColumns';

class AdvancementReportTable extends React.PureComponent {
  render() {
    const {
      items,
      showPrice,
      loading,
      orgIsPack = false,
      onAwardAdvancement,
    } = this.props;

    return (
      <Table
        size="small"
        headerColor="gray-1"
        rowKey="key"
        columns={columns(showPrice, orgIsPack, onAwardAdvancement)}
        dataSource={items}
        loading={loading}
        pagination={false}
        border={false}
      />
    );
  }
}

AdvancementReportTable.propTypes = {
  loading: PropTypes.bool.isRequired,
  showPrice: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  onAwardAdvancement: PropTypes.func.isRequired,
  orgIsPack: PropTypes.bool,
};

export default AdvancementReportTable;
